import {
  ActionIcon,
  Button,
  Card,
  Group,
  ScrollArea,
  Table,
  Text,
  TextInput,
} from '@mantine/core';
import { IoMdSearch } from 'react-icons/io';
import useSWR from 'swr';
import { useState } from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import { type Client, type Clients } from '@/schemas/API/GET/client/response';
import { getFetcher } from '../../../../api/fetchers';

export const ClientModal = ({
  closeModal,
  startIds,
}: {
  closeModal: (newClients: number[] | null) => void;
  startIds: number[];
}): JSX.Element => {
  const [chosenClients, setChosenClients] = useState<Client[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [query, setQuery] = useState<string>('');

  const handleChange = (client: Client) => {
    if (!chosenClients.includes(client)) {
      setChosenClients([...chosenClients, client]);
    } else {
      setChosenClients(
        chosenClients.filter(chosenClient => chosenClient.id !== client.id)
      );
    }
  };

  const { data: clients } = useSWR<Clients>(
    `clients?query=${query}`,
    getFetcher
  );

  const clientRows = chosenClients
    .concat(
      clients
        ? clients.content.filter(
            client =>
              !startIds.includes(client.id) &&
              !chosenClients.some(item => item.id === client.id)
          )
        : []
    )
    .map(element => (
      <Table.Tr key={element.id}>
        <Table.Td>
          <ActionIcon variant="transparent" color="darkblue" size="lg">
            <FaCalendarAlt />
          </ActionIcon>
        </Table.Td>
        <Table.Td>{element.firstName + ' ' + element.lastName}</Table.Td>
        <Table.Td align="right">
          <Button
            variant={
              chosenClients.some(client => element.id === client.id)
                ? 'filled'
                : 'outline'
            }
            radius="md"
            onClick={() => {
              handleChange(element);
            }}
          >
            {chosenClients.some(client => element.id === client.id)
              ? 'Odebrat'
              : 'Vybrat'}
          </Button>
        </Table.Td>
      </Table.Tr>
    ));

  return (
    <Card>
      <Text fw={700} size="lg">
        Vybrat nežádoucí klienty
      </Text>
      <TextInput
        size="md"
        mt="sm"
        mb="sm"
        placeholder="hledat"
        value={searchValue}
        onChange={event => setSearchValue(event.currentTarget.value)}
        onKeyDown={event => {
          if (event.key === 'Enter') setQuery(searchValue);
        }}
        leftSection={
          <ActionIcon
            variant="transparent"
            color="gray"
            onClick={() => {
              setQuery(searchValue);
            }}
          >
            <IoMdSearch />
          </ActionIcon>
        }
      />
      <ScrollArea h={500}>
        <Table>
          <Table.Tbody>{clientRows}</Table.Tbody>
        </Table>
      </ScrollArea>
      <Group justify="space-between" mt="lg">
        <Button
          variant="outline"
          radius="md"
          pl="xl"
          pr="xl"
          onClick={() => {
            closeModal(null);
          }}
        >
          Zrušit
        </Button>
        <Button
          variant="filled"
          radius="md"
          pl="xl"
          pr="xl"
          onClick={() => {
            closeModal([
              ...startIds,
              ...chosenClients.map(client => client.id),
            ]);
          }}
        >
          Potvrdit
        </Button>
      </Group>
    </Card>
  );
};
